export const getSearchPath = (query: string) => `/search?q=${query}`;
